export const ChatMessageSenderType = Object.freeze({
  USER: "user",
  BOT: "bot",
  SYSTEM: "system",
});

export const ChatSystemMessageType = Object.freeze({
  CLEAR_CHAT: "clear_chat",
});

export const ChatSystemMessage = Object.freeze({
  [ChatSystemMessageType.CLEAR_CHAT]: "This chat has been cleared.",
});
